import {showPopUp} from "./commonStatesSlice";

export function handleShowPopUp(dispatch, showForm, showEditForm, showHistory,showInsurance){
    if(showEditForm === true){
        dispatch(showPopUp({type: 'showEditForm', value: false}))
    }
    else if(showHistory === true){
        dispatch(showPopUp({type: 'showHistory', value: false}))
    }
    else if(showForm === true){
        dispatch(showPopUp({type: 'showForm', value: false}))
    }
      else if(showInsurance === true){
        dispatch(showPopUp({type: 'showInsurance', value: false}))
    }
}

